export const colors1 = ['#BD271E', '#B9867E', '#E9E7E1', '#247417', '#2B2A1C']
export const colors2 = ['#66584C', '#D6D4D5', '#4D403D', '#1E2222', '#8694A3']
export const colors3 = ['#2B3B4C', '#6E88A1', '#575161', '#CDB7AD', '#6B5D52']
export const colors4 = ['#7F514D', '#3D202C', '#AC8B71', '#D0C4B9', '#A27844']
export const colors5 = ['#F8D5D8', '#51202F', '#7A364F', '#E18B7C', '#F8D097']
export const colors6 = ['#173934', '#6497CB', '#C1B5C3', '#BF7E30', '#B62128']
export const colors7 = ['#E6D9D4', '#5C5354', '#434349', '#9C8B7A', '#E3C5A9']
export const colors8 = ['#BFD0DE', '#31517D', '#6496C4', '#5D464C', '#9A6A4E']
export const colors9 = ['#98AED3', '#955241', '#D48A43', '#27435F', '#0477CB']
export const colors10 = ['#B1B6E3', '#6877AF', '#74495A', '#8C6952', '#2D1D23']

export const colors11 = ['#E7C86B', '#A87443', '#642715', '#BE9DAF', '#62A6D0']
export const colors12 = ['#476408', '#9FB125', '#98C8DF', '#E0B328', '#AB2A17']
export const colors13 = ['#F2EEE5', '#7B8492', '#8B8D89', '#45839D', '#91ABB5']
export const colors14 = ['#1B1B1B', '#F8F8F8', '#9B9B9B', '#939393', '#8C8C8C']
export const colors15 = ['#C42636', '#F46277', '#DE4D51', '#E47975', '#FC9AAA']
export const colors16 = ['#8A2514', '#F59A1B', '#DA6524', '#6F2C14', '#110305']
export const colors17 = ['#BED6F2', '#123655', '#43739D', '#97B5DA', '#A6C3E5']
export const colors18 = ['#1996A4', '#A5BDBA', '#CD9464', '#DF892D', '#7B4826']
export const colors19 = ['#CFE0DE', '#363607', '#4B5C04', '#A8BC38', '#E6D734']
export const colors20 = ['#FCC403', '#DA9911', '#EC6C0F', '#CD4018', '#7C290A']

export const colors21 = ['#7473BD', '#A1B69B', '#D6A063', '#965D33', '#5C403C']
export const colors22 = ['#C6D2E0', '#6A97CB', '#262528', '#624224', '#DDAA1B']

export const allColors = [
    colors1,colors2, colors3, colors4, colors5, colors6, colors7, colors8, colors9, colors10,
    colors11, colors12, colors13, colors14, colors15, colors16, colors17, colors18, colors19,
    colors20, colors21, colors22 ]

export function isValidHEXColor (color: string, notRequired: boolean = false) : boolean {    
    const reg = /^#([0-9a-f]{3}){1,2}([0-9a-f]{2})?$/i
    const len = color ? color.length : 0
    
    if ((notRequired && len === 0) || color === 'transparent') {        
        return true
    }
    
    return color && reg.test(color) && [4,7,9].includes(len)
}